<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{ module }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboards' }">Dashboards</router-link>
              </li>
              <li class="breadcrumb-item active">{{ module }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-lg-flex align-items-center justify-content-between mb-4">
              <div class="align-items-center d-lg-flex d-none">
                <div class="form-group mb-0 align-items-center d-flex">
                  <label class="mb-0">Show</label>
                  <select class="form-control ml-3" v-model="show" @change="showLimit">
                    <option value="10">10</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>

                  <datepicker :minimumView="'month'" :maximumView="'year'" :initialView="'year'" format="MMM-yyyy"
                    input-class="form-control ml-2" v-model="year" @input="fetchData"></datepicker>
                </div>
              </div>
            </div>

            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Karyawan</th>
                  <th>Tanggal</th>
                  <th>Gaji</th>
                  <th>Total Lembur</th>
                  <th>Total Insentif</th>
                  <th>Total Tunjangan</th>
                  <th>Total Potongan</th>
                  <th>Total Gaji</th>
                  <th>Status</th>
                  <th>Aksi</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, i) in data" :key="i">
                  <td><b>{{ d.emp_name }}</b></td>
                  <td>{{ d.payroll != undefined ? d.payroll.date : '-' }}</td>
                  <td>{{ d.payroll != undefined ? "Rp " + numberWithCommas(d.payroll.gaji) : "Rp " + numberWithCommas(d.emp_gapok) }}</td>
                  <td>{{ d.payroll != undefined ? "Rp " + numberWithCommas(d.payroll.total_lembur) : "Rp " + numberWithCommas(0) }}</td>
                  <td>{{ d.payroll != undefined ? "Rp " + numberWithCommas(d.payroll.total_insentif) : "Rp " + numberWithCommas(0) }}</td>
                  <td>{{ d.payroll != undefined ? "Rp " + numberWithCommas(d.payroll.total_tunjangan) : "Rp " + numberWithCommas(0) }}</td>
                  <td>{{ d.payroll != undefined ? "Rp " + numberWithCommas(d.payroll.total_potongan) : "Rp " + numberWithCommas(0) }}</td>
                  <td>{{ d.payroll != undefined ? "Rp " + numberWithCommas(d.payroll.total_gaji) : "Rp " + numberWithCommas(d.emp_gapok) }}</td>
                  <td><span :class="d.payroll != undefined ? (d.payroll.status == 'Sudah' ? 'badge badge-success' : 'badge badge-danger') : 'badge badge-danger'">{{ d.payroll != undefined ? d.payroll.status : 'Belum' }}</span></td>
                  <td>
                    <button class="btn btn-warning mr-2" @click="edit(d.emp_uuid)"><i class="fa fa-pen"></i></button>
                    <button class="btn btn-primary" @click="slip(d.emp_uuid)"><i class="fa fa-print"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  data() {
    return {
      isLoading: false,
      module: "Payroll",
      table_module: "payroll",
      alias_table: "payroll",
      fields: {},
      data: {},
      show: 10,
      page: 1,
      totalData: 0,
      massData: [],
      visible: false,
      dataSearch: {},
      orderBy: 'created_at',
      sort: 'desc',
      year: new Date()
    };
  },
  computed: {
    local_users() {
      if (localStorage.getItem("users") != undefined) {
        return JSON.parse(localStorage.getItem("users"));
      }
      return {};
    },
  },
  components: {
    Datepicker
  },
  mounted() {
    if (typeof this.$route.query.page !== 'undefined') {
      this.page = this.$route.query.page
    }
    if (typeof this.$route.query.limit !== 'undefined') {
      this.limit = this.$route.query.limit
    }
    if (typeof this.$route.query.orderBy !== 'undefined') {
      this.orderBy = this.$route.query.orderBy
    }
    if (typeof this.$route.query.sort !== 'undefined') {
      this.sort = this.$route.query.sort
    }
    this.fetchData();
  },
  methods: {
    fetchData(arm) {
      this.isLoading = true;
      var params = {};
      if (arm == undefined) {
        params = {
          page: this.page,
          show: this.show,
          order_by: this.orderBy,
          type_sort: this.sort,
        };
      } else {
        params = {
          page: (arm.page == undefined) ? this.page : arm.page,
          show: (arm.show == undefined) ? this.show : arm.show,
          order_by: (arm.orderBy == undefined) ? this.orderBy : arm.orderBy,
          type_sort: (arm.sort == undefined) ? this.sort : arm.sort,
        };
      }
      params["search[periode]"] = this.$moment(this.year).format("MMM-YYYY");

      this.orderBy = params.order_by;
      this.sort = params.type_sort;

      if (this.dataSearch.search != undefined) {
        for (const key in this.dataSearch.search) {
          params["search[" + key + "]"] = this.dataSearch.search[key];
        }
      }

      this.axios
        .get("/" + this.table_module, { params: params })
        .then((response) => {
          this.fields = response.data.data.fields;
          this.data = response.data.data[this.module];
          this.isLoading = false;
        });
    },
    showLimit() {
      this.page = 1;
      this.fetchData();
    },
    massDelete(newValue) {
      if (newValue == null) {
        this.massData = [];
      } else {
        this.massData.push(newValue);
      }
    },
    uncheckMassDelete(newValue) {
      var index = this.massData.indexOf(newValue);
      this.massData.splice(index, 1);
    },
    processMassDelete() {
      var Swal = this.$swal;
      Swal.fire({
        title: "Yakin ingin hapus data yang dipilih?",
        // text: "You will not be able to recover this imaginary file!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then((result) => {
        if (result.value) {
          this.axios
            .post("/" + this.table_module + "/mass_delete", this.massData)
            .then((response) => {
              if (response.data.status == 200) {
                this.massData = []; // reset mass data
                this.fetchData();
              }
            });
        }
      });
    },
    paramSearch(arm) {
      this.page = 1;
      this.show = 10;
      this.dataSearch = arm;
      this.fetchData();
    },
    loading(arm) {
      if (arm == true) {
        this.fields = {};
        this.data = {};
      }
    },
    numberWithCommas(arm) {
      if (arm != "" && arm != null) {
        return arm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return 0;
    },
    edit(uuid) {
      this.$router.push({
        name: this.table_module + "_edit",
        params: { uuid: uuid, year :  this.$moment(this.year).format("MMM-YYYY") },
      });
    },
    slip(uuid) {
      this.$router.push({
        name: this.table_module + "_slip",
        params: { uuid: uuid, periode :  this.$moment(this.year).format("MMM-YYYY") },
      });
    },
  },
};
</script>